<template>
	<div class="template money" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span> </label>
			<input class="input_value" :change="changeVal(dataVal.Property.Title[0].Text)" :readOnly="dataVal.Disable"  v-model="dataVal.Value" type="text" placeholder="请输入" />
		</div>
	</div>
</template>

<script>
	export default{
		props: ['dataVal'],
		data(){
			return{
				
			}
		},
		mounted() {
		},
		methods: {
			changeVal(val) {
				var value = this.dataVal.Value;
				if(value == null){
					return;
				}
				this.dataVal.Value = (value.toString().match(/^\d{0,9}(\.\d{0,2}){0,1}/g)[0]) || null;
				this.$emit('child-event', this.dataVal.Value, val);
			}
		}
	}
</script>

<style scoped>
::v-deep .el-input-number {
  position: relative;
  display: inline-block;
  width: 220px;
  line-height: 38px;
}
</style>

<!--<style>-->
<!--	@import '../assets/css/common.css';-->
<!--</style>-->